import { render } from "./KioskFooter.vue?vue&type=template&id=a7b1bc84"
import script from "./KioskFooter.vue?vue&type=script&lang=js"
export * from "./KioskFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__